const getArrayIndex = (str) => {
    return getArrayIndex.regexpNaNIndex.exec(str) || getArrayIndex.regexpIntIndex.exec(str);
};
getArrayIndex.regexpIntIndex = /\[(-*\d*)]/g;
getArrayIndex.regexpNaNIndex = /\[([^\]]*)]/;
export default getArrayIndex;
//# sourceMappingURL=get-array-index.js.map